module.exports = __webpack_public_path__ + "static/media/4.25debd73.jpeg";